import { create } from 'zustand';
import { authDisplayName, deriveAccountType, hasGoogleProvider } from '../utils/authIdentity';
import { partitionSessions } from '../utils/sessionHistory';

/**
 * Snapshot of the signed-in Firebase user for UI use.
 *
 * Only display-safe fields are kept. The raw Firebase user object (which
 * carries token managers and provider data) is never stored.
 */
export function toUserSnapshot(user) {
  if (!user?.uid) return null;
  return {
    uid: user.uid,
    displayName: authDisplayName(user) || null,
    photoURL: typeof user.photoURL === 'string' ? user.photoURL : null,
    accountType: deriveAccountType(user),
    isGoogleAccount: hasGoogleProvider(user),
  };
}

const useUserStore = create((set, get) => ({
  user: null,
  profile: null,
  sessions: [],
  sessionsLoading: false,

  setUser: (user) => set({ user: toUserSnapshot(user) }),
  setProfile: (profile) => set({ profile: profile || null }),
  setSessions: (sessions) => set({
    sessions: Array.isArray(sessions) ? sessions : [],
    sessionsLoading: false,
  }),
  setSessionsLoading: (loading) => set({ sessionsLoading: Boolean(loading) }),

  clearUser: () => set({ user: null, profile: null, sessions: [], sessionsLoading: false }),

  isGoogleAccount: () => get().user?.isGoogleAccount === true,

  getSessionGroups: (options = {}) => partitionSessions(get().sessions, options),
}));

export default useUserStore;
